import { Pipe, PipeTransform } from '@angular/core';

import { Enclosure } from '../../prisma-xs/models/prisma-xs.model';
import { isPrismaXsEnclosure } from '../../shared/helpers/prisma-xs.helper';
import { IConfigurationEnclosure } from '../../shared/models/enclosure.model';

@Pipe({
    name: 'enclosureConversion',
    standalone: false
})
export class EnclosureConversionPipe implements PipeTransform {

  transform(enclosure: IConfigurationEnclosure): Enclosure {
    if (!enclosure || !isPrismaXsEnclosure(enclosure)) {
      return;
    }

    const configuration = enclosure.configuration;

    return {
      configurationDimensions: configuration?.details?.dimensions,
      configurationFields: configuration.fields,
      configurationRows: configuration.rows,
      configurationIp: configuration?.details?.ip,
      configurationHasDoor: configuration?.details?.hasDoor,
      configurationType: configuration?.type,
      socleHeight: configuration?.socleHeight
    };
  }
}
